var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"status"},[_c('Tag',{style:(_vm.Style),attrs:{"type":_vm.statusC,"size":"small"}},[_vm._v(_vm._s(_vm.textC))])],1)}
var staticRenderFns = []

export { render, staticRenderFns }